import i18n from 'services/base/i18n';

export default {
  // Navigation bar option that goes to the home page
  home: () => i18n.pgettext('Components|Navigation', 'Home'),
  // Navigation bar option that goes to the list of devices
  devices: () => i18n.pgettext('Components|Navigation', 'Devices'),
  // Navigation bar option that goes to the list of security issues
  issues: () => i18n.pgettext('Components|Navigation', 'Alerts'),
  // Navigation bar option that goes to a full list of other pages of the app
  more: () => i18n.pgettext('Components|Navigation', 'More'),
};
